import React, { useContext, useEffect, useState } from 'react';
import '../css/about.css';
import ReactMarkdown from 'react-markdown';
import { Container, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import Header from './Header';
import endpoints from '../constants/endpoints';
import FallbackSpinner from './FallbackSpinner';
import Footer from './Footer';
import AppContext from '../AppContext';
import { getTranslation } from '../constants/translations';

const styles = {
  introTextContainer: {
    margin: 10,
    whiteSpace: 'pre-wrap',
    textAlign: 'left',
    fontSize: '1.2em',
    fontWeight: 500,
  },
  introImageContainer: {
    margin: 10,
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
  },
};

function About({ header }) {
  const { language } = useContext(AppContext);
  const t = getTranslation(language);
  const [data, setData] = useState(null); // Data fetched
  const [isLoading, setIsLoading] = useState(true); // Loading state

  // Fetch About data
  useEffect(() => {
    fetch(endpoints.about, {
      method: 'GET',
    })
      .then((res) => res.json())
      .then((res) => {
        setData(res);
        setIsLoading(false); // Data is ready
      })
      .catch((err) => console.error('Error loading about data:', err));
  }, []);

  const parseIntro = (text) => <ReactMarkdown children={text} />;

  return (
    <>
      {isLoading ? (
        <FallbackSpinner /> // Show spinner while loading
      ) : (
        <Fade>
          <div className="fade-in">
          <div className="header-container">
          <Header title={header} />
        </div>

            <Container>
             
                  {parseIntro(t.about?.content || data.about)}
                
              
            </Container>
            <Footer /> {/* Move Footer here for consistent placement */}
          </div>
        </Fade>
      )}
    </>
  );
}

About.propTypes = {
  header: PropTypes.string.isRequired,
};

export default About;
